import React, { useEffect, useMemo, useState, useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { Button, Card, Container, Group, Title, ActionIcon, Tooltip, Modal, Text, Box } from '@mantine/core';
import { FaArrowLeft, FaEdit, FaTrash } from 'react-icons/fa';
import AddBatchForm from '../forms/AddBranchForm';
import './Branches.css';
import { getBranches, editBranch, addBranch, deleteBranch } from '../../axios';
import authContext from '../../AuthContext';
import { useNavigate } from 'react-router-dom';

const Batches = () => {
  const [showForm, setShowForm] = useState(false);
  const [data, setData] = useState([]);
  const { user, userType } = useContext(authContext);
  const [editBatch, setEditBatch] = useState(null); // State for editing batch
  const [update, setUpdate] = useState(false); // State to trigger updates
  const [confirmDelete, setConfirmDelete] = useState(false); // State for delete confirmation modal
  const [batchToDelete, setBatchToDelete] = useState(null); // Batch to be deleted
  const navigate = useNavigate();

  // Handle add or edit batch form submission
  const handleAddBatch = async (branch) => {
    if (editBatch) {
      //console.log(editBatch)
      // Update the batch
      const res = await editBranch(branch);
      //console.log(res)
      setUpdate(!update);
      setShowForm(false);
      setEditBatch(null); // Reset edit state
    } else {
      const res = await addBranch(branch);
      //console.log(res)
      setUpdate(!update);
      setShowForm(false);
    }
  };

  // Handle row edit
  const handleEdit = (row) => {
    //console.log(row.original)
    setEditBatch(row.original);
    setShowForm(true);
  };

  // Handle row delete
  const handleDelete = (row) => {
    setBatchToDelete(row.original);
    setConfirmDelete(true); // Open the confirmation modal
  };
const handleBackClick=()=>{
  setShowForm(false)
  setEditBatch(null)
}
  // Confirm batch deletion
  const confirmDeleteBatch =async() => {
    if (batchToDelete) {
      const res=await deleteBranch(batchToDelete.id);
        if(res){
              setUpdate(!update); // Toggle update state to refresh data
              setConfirmDelete(false); // Close the dialog
            }
            else{
              console.error('Error deleting Branch'); // Log the error
              setConfirmDelete(false); // Close the dialog even on error
            };
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'serialNumber',
        header: 'No.',
        Cell: ({ row }) => row.index + 1, // Display row number
        size: 60,
      },
      {
        accessorKey: 'branch_id',
        header: 'Branch ID',
      },
      {
        accessorKey: 'branch_name',
        header: 'Branch Name',
      },
      {
        accessorKey: 'name',
        header: 'Admin Name',
      },
      {
        accessorKey: 'contact',
        header: 'Contact',
      },
      {
        accessorKey: 'email',
        header: 'Email',
      },
      ...(userType === 'sa'
        ? [
            {
              accessorKey: 'actions',
              header: 'Actions',
              Cell: ({ row }) => (
                <Group spacing="sm">
                  <Tooltip label="Edit Branch">
                    <ActionIcon color="teal" onClick={() => handleEdit(row)}>
                      <FaEdit size={16} />
                    </ActionIcon>
                  </Tooltip>
                  <Tooltip label="Delete Branch">
                    <ActionIcon color="red" onClick={() => handleDelete(row)}>
                      <FaTrash size={16} />
                    </ActionIcon>
                  </Tooltip>
                </Group>
              ),
            },
          ]
        : [] // No actions column for non-'sa' users
      ),
    ],
    [userType] // Add userType as a dependency
  );

  useEffect(() => {
    const branchList = async () => {
      const res = await getBranches();
      setData(res.data);
    };
    branchList();
  }, [update, user]); // Add user to dependency array

  const table = useMantineReactTable({
    columns,
    data,
  });

  return (
    <Container size="lg" style={{ marginTop: '20px', padding: '20px' }}>
      {showForm ? (
        <>
          <Group position="left" mb="md">
            <ActionIcon variant="outline" color="gray" onClick={handleBackClick}>
                         <FaArrowLeft size={16} />
                       </ActionIcon>
          </Group>
          <AddBatchForm onSubmit={handleAddBatch} branchData={editBatch} />
        </>
      ) : (
        <>
          <Group position="apart" mb="md">
            <Title order={2} style={{ color: '#2c7a3b' }}>Branch List</Title>
            {userType === 'sa' && (
            <Button color="green" variant="outline" onClick={() => setShowForm(true)}>
                            Add Branch
                          </Button>
            )}
          </Group>
             <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <MantineReactTable table={table} />
                      </Card>
        </>
      )}

      {/* Delete confirmation modal */}
      <Modal
        opened={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        title="Confirm Deletion"
        centered
        overlayColor="rgba(0, 0, 0, 0.5)"
        overlayOpacity={0.5}
        overlayProps={{ blur: 4 }}
      >
        <Box>
          <Text>Do you want to delete {batchToDelete ? batchToDelete.branch_name : ''}?</Text>
          <Group position="right" mt="md">
            <Button variant="outline" onClick={() => setConfirmDelete(false)} style={{ color: '#2c7a3b' }}>
              Cancel
            </Button>
            <Button color="red" onClick={confirmDeleteBatch}>
              Confirm
            </Button>
          </Group>
        </Box>
      </Modal>
    </Container>
  );
};

export default Batches;
